import { CREATE_BILL, RETRIEVE_BILL, DELETE_BILL } from "./types";

import BillDataService from "../services/bill.service";
import { parseNumber } from "../helpers/common";

export const createBill =
	(
		id,
		id_company,
		id_sales,
		id_card,
		code,
		code_po,
		date,
		due_date,
		note,
		ship_to,
		tax_inclusive,
		detail,
		recurring,
		recurring_name
	) =>
	async (dispatch) => {
		try {
			if (tax_inclusive === "true") {
				tax_inclusive = true;
			}
			if (tax_inclusive === "false") {
				tax_inclusive = false;
			}

			code = code.toString();
			id_sales = parseNumber(id_sales);
			id_card = parseNumber(id_card);

			let formData = {
				id: id,
				id_company: id_company,
				id_sales: id_sales,
				id_card: id_card,
				code: code,
				code_po: code_po,
				date: date,
				due_date: due_date,
				note: note,
				ship_to: ship_to,
				tax_inclusive: tax_inclusive,
				detail: detail,
				recurring: recurring,
				recurring_name: recurring_name,
			};

			const res = await BillDataService.create(formData);

			dispatch({
				type: CREATE_BILL,
				payload: res.data,
			});

			return Promise.resolve(res.data);
		} catch (err) {
			return Promise.reject(err);
		}
	};

export const retrieveBill = (params) => async (dispatch) => {
	try {
		const res = await BillDataService.getAll(params);

		dispatch({
			type: RETRIEVE_BILL,
			payload: res.data,
		});
	} catch (err) {
		return Promise.reject(err);
	}
};

export const deleteBill = (id) => async (dispatch) => {
	try {
		const res = await BillDataService.delete(id);

		dispatch({
			type: DELETE_BILL,
			payload: res.data,
		});
	} catch (err) {
		return Promise.reject(err);
	}
};
